export const OPERATING_FLUID_URL_ADDRESS = 'operatingfluids.mercedes-benz.com';
